(function () {
  function init() {
    var mq = window.matchMedia('(min-width: 990px)');
    var menus = document.querySelectorAll('.header__inline-menu header-menu');

    menus.forEach(function (menu) {
      var details = menu.querySelector(':scope > details');
      if (!details) return;

      var closeTimer;

      menu.addEventListener('mouseenter', function () {
        if (!mq.matches) return;
        clearTimeout(closeTimer);
        if (!details.hasAttribute('open')) {
          details.setAttribute('open', '');
        }
      });

      menu.addEventListener('mouseleave', function () {
        if (!mq.matches) return;
        closeTimer = setTimeout(function () {
          details.removeAttribute('open');
        }, 150);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();